module.exports = __webpack_public_path__ + "static/img20-32c3c250ceb6a94a27ef75d58604ac99.jpg";